module.exports = __webpack_public_path__ + "static/media/ntakirutimana_masaka6.8ce0119a.png";